<template>
	<div class="layout-view">
		<erco-layout-template-selection v-if="sites.length === 0 && sitesFinishedLoading"
		                                :sets="templateSets">
		</erco-layout-template-selection>

		<erco-layout-preview-block v-if="sites.length > 0"
			                       class="preview-block"
		                           :datasets="sites">
		</erco-layout-preview-block>

		<erco-back-to-top-button thresholdType="windowHeight"></erco-back-to-top-button>
	</div>
</template>

<script>
	import ErcoLayoutTemplateSelection from '@/components/molecules/ErcoLayout/TemplateSelection';
	import ErcoLayoutPreviewBlock from '@/components/molecules/ErcoLayout/PreviewBlock';

	import ErcoBackToTopButton from '@/components/atoms/ErcoBackToTopButton';

	export default {
		name: 'ErcoObjectViewLayoutOrganism',

		data() {
			return {
				$preview: null,
			};
		},

		props: {
			dataset: {
				type: Object,
				required: true,
			},
		},

		computed: {
			sites() {
				return this.$store.getters.mappedSiteData || {};
			},
			sitesFinishedLoading() {
				return this.$store.state.objectsites.sitesFinishedLoading;
			},
			templateSets() {
				return this.$store.state.objectsites.templateSets;
			},
		},

		components: {
			ErcoLayoutTemplateSelection,
			ErcoLayoutPreviewBlock,

			ErcoBackToTopButton,
		},
	};
</script>

<style lang="scss">

	.layout-view {
		width: 100%;
	}

</style>



// WEBPACK FOOTER //
// Layout.vue?53d8539e